<template>
  <div v-if="screener_date">
    <countdown
      :end-time="moment.utc
                (screener_date)
                .local().format()
            "
      @finish="onFinish"
    >
      <template slot="process" slot-scope="{timeObj}">
        <v-layout style="direction: initial;" row wrap align-center justify-center class="my-5">
          <v-flex xs3 sm2 md2 class="mb-2">
            <div :class="[$vuetify.breakpoint.width < 600 ?'display-1' :'display-4', 'primary--text', 'font-family-Whitney-Book']">{{ timeObj.d }}</div>
            <div
              :class="[$vuetify.breakpoint.width < 600 ?'body-2' :'title', 'primary--text', 'font-weight-bold']"
            >{{$t('screening.countdown.days')}}</div>
          </v-flex>
          <!-- <v-divider vertical class="primary"></v-divider> -->
          <v-flex xs3 sm2 md2 class="mb-2">
            <div
              :class="[$vuetify.breakpoint.width < 600 ?'display-1' :'display-4', 'primary--text', 'font-family-Whitney-Book']"
            >{{ timeObj.h }}</div>
            <div
              :class="[$vuetify.breakpoint.width < 600 ?'body-2' :'title', 'primary--text', 'font-weight-bold']"
            >{{$t('screening.countdown.hours')}}</div>
          </v-flex>
          <!-- <v-divider vertical class="primary"></v-divider> -->
          <v-flex xs3 sm2 md2 class="mb-2">
            <div :class="[$vuetify.breakpoint.width < 600 ?'display-1' :'display-4', 'primary--text', 'font-family-Whitney-Book']">{{ timeObj.m }}</div>
            <div
              :class="[$vuetify.breakpoint.width < 600 ?'body-2' :'title', 'primary--text', 'font-weight-bold']"
            >{{$t('screening.countdown.minutes')}}</div>
          </v-flex>
          <!-- <v-divider vertical class="primary"></v-divider> -->
          <v-flex xs3 sm2 md2 class="mb-2">
            <div :class="[$vuetify.breakpoint.width < 600 ?'display-1' :'display-4', 'primary--text', 'font-family-Whitney-Book']">{{ timeObj.s }}</div>
            <div
              :class="[$vuetify.breakpoint.width < 600 ?'body-2' :'title', 'primary--text', 'font-weight-bold']"
            >{{$t('screening.countdown.seconds')}}</div>
          </v-flex>
        </v-layout>
      </template>
    </countdown>
  </div>
</template>

<script>
import vueAwesomeCountdown from "vue-awesome-countdown";
export default {
  name: "ScreenerCountDown",
  props: {
    screener_date: {
      default: null
    }
  },
  methods: {
    onFinish() {
      this.$emit("finished");
    }
  }
};
</script>

<style scoped>
.font-family-Whitney-Book {
  font-family: "Whitney-Book" !important;
  letter-spacing: 0 !important;
}
</style>
